import { createTheme } from "@mui/material/styles";
import ThemeOption from "./themeOption.js";

export default createTheme(ThemeOption);
